module.exports = __webpack_public_path__ + "static/01-af8a00d4716ca0614673e32827e55ff7.jpg";